import React from 'react';
import { AB_TITLE, CREATE_AB_TEST } from '../../utils/Constants';
import Button from 'Components/DesignSystem/Button/Button';
import Typography from 'Components/DesignSystem/Typography/Typography';

type TABHomeHeaderProps = {
    onOpen: () => void;
    hasCreatePermission: boolean
}

/**
 * The list page header (`okf/design-system/e2e.md` § 139).
 *
 * The title was a `<label>` with no `htmlFor` — a labelling element used as a heading,
 * so a screen-reader user navigating this page by heading found nothing. It is now
 * `Typography as="h1"` on `heading-2`, the same pairing § 134 settled on for
 * `/admin/settings`.
 *
 * `id`s and the `ab-create-btn` testid are unchanged: several specs key off both.
 */
const ABHomeHeader = ({ onOpen, hasCreatePermission }: TABHomeHeaderProps) => {
    return (
        <div id="ab-test-header" className="tw-flex tw-justify-between tw-items-center tw-border-b tw-border-edge tw-my-2 tw-pb-1.5">
            <Typography
                variant="display"
                as="h1"
                id="ab-test-title"
                className="tw-text-ink"
                data-testid="ab-page-title"
            >
                {AB_TITLE}
            </Typography>
            <Button
                variant="primary"
                id="ab-test-btn-create"
                data-testid="ab-create-btn"
                disabled={!hasCreatePermission}
                onClick={onOpen}
            >
                {CREATE_AB_TEST}
            </Button>
        </div>
    );
}

export default ABHomeHeader;
